import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const ItemGroup = ({
  fetchData,

}) => {
  const {GetItemGrp} = useSelector((state) => state.itemPage);
  const [groupCode, setGroupCode] = useState("");

  const handleGroupCodeChange = (groupCode) => {
    setGroupCode(groupCode);
    fetchData(groupCode);
  };

  return (
    <div className="d-none  col-2 flex-column categoryDiv">
      {GetItemGrp && GetItemGrp.length > 0 ? (
        GetItemGrp.map((group, index) => (
          <button
            className="categoryButton mb-auto"
            key={index}
            onClick={() => handleGroupCodeChange(group?.itmsGrpCod)}
          >
            {group?.itmsGrpNam}
          </button>
        ))
      ) : (
        <li>No data available</li>
      )}
    </div>
  );
};

export default ItemGroup;
